define('view/controller/review/ReviewItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * reviews item view
     *
     * @class reviewsItemView
     */
    return LayoutView.extend({

        template: '#reviews_item_view',

        ui : {
            'likeBtn' : '#sb_client_review_item_like',
            'dislikeBtn' : '#sb_client_review_item_dislike',
            'removeBtn' : '.sb_client_review_delete',
        },

        triggers: {
            'click @ui.likeBtn': 'like_review',
            'click @ui.dislikeBtn': 'dislike_review',
            'click @ui.removeBtn': 'delete_review',
        },

        opts : {},

        initialize: function(options) {
            if(_.isObject(options)){
                this.opts = options;
            }
        },

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            result['is_logged_in'] = this.opts && this.opts['logged_in'];
            return result;
        },

    });

});
